"use strict";function o(o){return o&&"object"==typeof o&&"default"in o?o:{default:o}}var t=o(require("styled-components")).default.section`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 11px;
    box-sizing: border-box;
    align-items: center;

    .button-wrapper {
        .DXButton {
            width: 32px;
            outline: none;
            height: 32px;
            border-radius: 100%;
            overflow: hidden;
            padding: 0;
            color: ${({theme:o})=>o.colors.primary.dark};
            position: relative;
            z-index: 5;
            justify-content: center;
            transform: translateX(-100%);
            opacity: 0;
            transition: 'transform 0.2s ease-in-out, opacity 0.2s ease-in-out, border-color .2s ease-in-out, color .2s ease-in-out';

            .background {
                background: ${({theme:o})=>o.colors.common.light};
                border-color: ${({theme:o})=>o.colors.common.light};
            }

            &:hover,
            &:focus,
            &:active {
                color: ${({theme:o})=>o.colors.common.light};
                
                .background {
                    border-color: ${({theme:o})=>o.colors.primary.default};
                    background: ${({theme:o})=>o.colors.primary.default};
                }
            }
        }
    }

    span.button-wrapper:last-of-type {
        .DXButton {
            transform: translateX(100%);

            svg {
                transform: rotate(180deg);
            }
        }
    }

    svg {
        width: 20px;
        height: 20px;
        margin: 0;

        path {
            fill: currentColor;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
